module.exports = __webpack_public_path__ + "static/img/11.d1bbc2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/11.png
// module id = Yz7m
// module chunks = 0